import axios, { AxiosRequestConfig } from 'axios'

type ClientOption = {
  data?: any;
  token?: any;
} & AxiosRequestConfig;

let base_uri = process.env.REACT_APP_API_URL;
if (process.env.NODE_ENV !== 'development') {
  base_uri = window.location.origin;
} else if (window.location.host.indexOf('localhost') > -1) {
  base_uri = window.location.origin;
}

async function client(
  endpoint: string,
  {data, token, headers: customHeaders, ...customConfig}: ClientOption = {},
) {
  const config: AxiosRequestConfig = {
    method: data ? 'post' : 'get',
    withCredentials: true,
    data,
    headers: {
      'Content-Type': 'application/json',
      ...customHeaders,
    },
    ...customConfig,
  };

  if (token && typeof token === 'string') {
    // @ts-ignore
    config.headers.authorization = `Bearer ${token}`;
  }
  return axios({
    baseURL: `${base_uri}/api/`,
    url: `${endpoint}`,
    ...config,
  }).then(response => {
    return response.data;
  }).catch(async ({ response }) => {
    if (response.status === 401) {
      throw {
        code: 401,
        message: 'No authorized'
      };
    }

    const isBlob = response.data instanceof Blob
    if (isBlob) {
      const data = await response.data.text();
      throw JSON.parse(data);
    }
    throw response.data;
  });
}

async function get(endpoint: string, options?: Omit<ClientOption, 'method'>) {
  return await client(endpoint, {method: 'get', ...options});
}

async function post(endpoint: string, options?: Omit<ClientOption, 'method'>) {
  return await client(endpoint, {method: 'post', ...options});
}

async function put(endpoint: string, options?: Omit<ClientOption, 'method'>) {
  return await client(endpoint, {method: 'put', ...options});
}

async function deleteClient(
  endpoint: string,
  options?: Omit<ClientOption, 'method'>,
) {
  return await client(endpoint, {method: 'delete', ...options});
}

const api = {
  get,
  post,
  put,
  delete: deleteClient,
};
export {client, api};
